module.exports = __webpack_public_path__ + "static/media/LTC-BNB.eb5fc85d.svg";